<template>
  <div class="shop-list">
   

<div class="container-landing filter-row">
  <span class="f-21 medium filter-label">{{$fn.tr('დაალაგე')}}:</span>
  <el-select v-model="filterVal" placeholder="" :popper-append-to-body="false">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      
      >
    </el-option>
  </el-select>
</div>
      <div class="shop-list-inner-wrapper container-landing">
       

        <div class="shop-list-box" v-for="(shop, index) in getContent" :key="index">
                     <div v-if="shop.svg" v-html="shop.svg" class="shop-sticker"></div>
            <router-link :to="$store.getters['main/getSingleUrl'](shop)" class="shop-list-box-img-wrapper">
              <div class="arrows-wrapper" v-if="shop.images.length > 1">
                 <div class="prev-btn pointer" @click="prevPic($event)">
         <svg xmlns="http://www.w3.org/2000/svg" width="35.581" height="27.07" viewBox="0 0 35.581 27.07">
  <g id="Group_3395" data-name="Group 3395" transform="translate(734.307 630.535) rotate(-180)">
    <g id="Group_3386" data-name="Group 3386" transform="translate(725.019 602.26)" opacity="0.3">
      <g id="menu" transform="translate(-24.753 3.741)">
        <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
          <path id="Union_6" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#101820" stroke="#101820" stroke-width="1"/>
        </g>
      </g>
    </g>
    <g id="Group_1490" data-name="Group 1490" transform="translate(724.019 600.26)">
      <g id="menu-2" data-name="menu" transform="translate(-24.753 3.741)">
        <g id="Group_103-2" data-name="Group 103" transform="translate(0 0)">
          <path id="Union_6-2" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#fff" stroke="#fff" stroke-width="1"/>
        </g>
      </g>
    </g>
  </g>
</svg>

        </div>
        <div class="next-btn pointer" @click="nextPic($event, shop.images)">
          <svg xmlns="http://www.w3.org/2000/svg" width="35.581" height="27.07" viewBox="0 0 35.581 27.07">
  <g id="Group_3387" data-name="Group 3387" transform="translate(-698.726 -603.465)">
    <g id="Group_3386" data-name="Group 3386" transform="translate(725.019 602.26)" opacity="0.3">
      <g id="menu" transform="translate(-24.753 3.741)">
        <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
          <path id="Union_6" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#101820" stroke="#101820" stroke-width="1"/>
        </g>
      </g>
    </g>
    <g id="Group_1490" data-name="Group 1490" transform="translate(724.019 600.26)">
      <g id="menu-2" data-name="menu" transform="translate(-24.753 3.741)">
        <g id="Group_103-2" data-name="Group 103" transform="translate(0 0)">
          <path id="Union_6-2" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#fff" stroke="#fff" stroke-width="1"/>
        </g>
      </g>
    </g>
  </g>
</svg>

        </div>
              </div>
                 <img v-for="(img, index) in shop.images" :key="index" :src="img.url" alt="" :class="{active: index === shop.images.length -1}"> 
                 <!-- <img :src="require('@/assets/img/' + currentPic(shop.img))" alt="">  -->
                <router-link :to="$store.getters['main/getSingleUrl'](shop)" class="buy-btn">
                  <span class="f-30">{{$fn.tr('შეძენა')}}</span>
                </router-link>
            </router-link>
          
           <div class="shop-list-box-text-block">
          
               <span class="f-21 bold-italic shop-desc">{{shop.title}}</span>
                    <span class="f-21 light-italic shop-price old-price" v-if="shop.oldprice !== 0">{{shop.oldprice}} ₾</span>
                    <span class="f-21 bold-italic shop-price">{{shop.price}} ₾</span>
              
           </div>
      </div>

     

      </div>
      <div class="show-more" v-if="getContent.length < listCount" @click="showMore()">
     
          <span class="f-30">{{ $fn.tr('მეტის ჩვენება') }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="22.988" height="31.675" viewBox="0 0 22.988 31.675">
  <g id="Group_104" data-name="Group 104" transform="translate(26.193 25.292) rotate(90)">
    <g id="menu" transform="translate(-24.754 3.74)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M14.188,18.549a58.283,58.283,0,0,1,7.4-5.171c.715-.424,1.448-.829,2.2-1.182-1.091-.045-2.205,0-3.308.045-1.171.049-2.329.094-3.434.039-4.772-.258-9.5-1.134-14.285-1.043-1.647.027-4.351-2.44-1.56-2.492,5.429-.1,10.753.977,16.168,1.092.9.017,1.815,0,2.742-.025a29.737,29.737,0,0,1,6.123.291C23.565,7.291,20.5,4.854,18.2,1.7c-.692-.945-.142-2.5.8-1.2,2.773,3.807,6.667,6.576,9.641,10.209a1.562,1.562,0,0,1,.248.424,1.243,1.243,0,0,1,.392.951c0,.042,0,.081,0,.118-.024.716-1.047.863-2.069.626a14.12,14.12,0,0,0-5.341,2.45,65.534,65.534,0,0,0-6.1,4.352,1.4,1.4,0,0,1-.9.3C14.039,19.925,13.278,19.3,14.188,18.549Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.043)" fill="#044b30" stroke="#044b30" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>

      </div>
  </div>
</template>

<script>
import fn from "../../helpers/func";
import moment from "moment";
export default {
  props: ['contentData'],
data(){
    return{
      currentIndex: 0,
      origshopList: this.$store.state.main.shopList,
        options: [{
          value: 'sortByDate',
          label: this.$fn.tr('ახალი დამატებული') 
        }, {
          value: 'sortByAsc',
          label: this.$fn.tr('ფასის ზრდით') 
        },
        {
          value: 'sortByDesc',
          label: this.$fn.tr('ფასის კლებით') 
        },

        
        ],
       pageCounter: 1,
      filterVal: 'sortByDate',
        shopToShow: 9,
        byDate: '',
        byDates: [],
        getContent: _.get(this.contentData, 'data.list'),
        
    }
},
computed: {
   listCount(){
      return _.get(this.contentData, 'data.listCount');
    },
    shopList(){
      let shop = this.$store.state.main.shopList;
      for (let i = 0; i < shop.length; i++) {
        //let formattedDate = moment(shop[i].dateAdded).format("DD.MM.YYYY");
        let formattedDate = new Date(shop[i].dateAdded);
        shop[i].dateAdded = formattedDate;
        // return shop;

     
           
      }
       
       if(this.filterVal === 'sortByDate'){
         
        shop = shop.slice(0, this.shopToShow).sort(this.compare);
      
       }  
       
        return shop.slice(0, this.shopToShow);
    },

    
    remainder(){
        if(this.origshopList.length - this.shopToShow <= this.shopToShow){
            return this.origshopList.length - this.shopToShow;
        } else {
            return 9;
        }
       
       
    }
},

methods: {
  currentPic(imgArr){
   
    return imgArr[0];
  },
  	nextPic(e, imgArr) {
    
     e.stopPropagation();
    e.preventDefault();

    let img = e.currentTarget.parentElement.parentElement.querySelectorAll("img");
    let imgDup = [...e.currentTarget.parentElement.parentElement.querySelectorAll("img")];
     let active = e.currentTarget.parentElement.parentElement.querySelector(".active");
       
     let activeIndex = imgDup.indexOf(active);
    
     
   
   
   if(activeIndex == img.length -1){
  
      active.classList.remove("active");
      img[0].classList.add("active");
 
  
    activeIndex = imgDup.indexOf(active);
      
      
    } else {
     img[activeIndex].classList.remove("active");
    
    img[activeIndex +1].classList.add("active");
      
    }

 
  
      
    
  
    
     
    },
  	prevPic(e) {
    e.stopPropagation();
    e.preventDefault();
    let img = e.currentTarget.parentElement.parentElement.querySelectorAll("img");
    let imgDup = [...e.currentTarget.parentElement.parentElement.querySelectorAll("img")];
     let active = e.currentTarget.parentElement.parentElement.querySelector(".active");
       
     let activeIndex = imgDup.indexOf(active);

     
   
   
   if(activeIndex == 0){
  
      active.classList.remove("active");
      img[img.length -1].classList.add("active");
 
  
    activeIndex = imgDup.indexOf(active);
      
     
    } else {
     img[activeIndex].classList.remove("active");
    
    img[activeIndex -1].classList.add("active");
   
    }

   
  
  
    },
  compare(a, b) {
      if (a.dateAdded > b.dateAdded) return -1
      else if (a.dateAdded < b.dateAdded) return 1
      else return 0
    },
  
     async showMore(){
    
      setTimeout(() => {
          this.$store.commit("main/updateLsStatus", !this.$store.state.main.updateLs);
      }, 500);
      setTimeout(() => {
          this.$store.commit("main/updateLsStatus", !this.$store.state.main.updateLs);
      }, 600);
     this.pageCounter += 1;  
     let params = {
          id: _.get(this.$store.state.main.selected_menu, "id"),
        pageNumber: this.pageCounter,
        componentUnicId: _.get(this.contentData, "conf.unicId"),
     };
     
     let res = await fn.postData('main/getDataList', params);
    //  console.log(res)
     this.getContent = this.getContent.concat(res.data.list);
    //  if(this.filterVal) this.getContent = this.getContent.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
        if(this.filterVal == 'sortByDate'){
          this.getContent = this.getContent.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));

        } else if(this.filterVal == 'sortByDesc'){
          this.getContent = this.getContent.sort((a, b) => b.price - a.price);

        } else if(this.filterVal == 'sortByAsc'){
          this.getContent = this.getContent.sort((a, b) => a.price - b.price);

        }
      
    }
},
  watch: {
      filterVal(ns, os){
        if(ns == 'sortByDate'){
          this.getContent = this.getContent.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));

        } else if(ns == 'sortByDesc'){
          this.getContent = this.getContent.sort((a, b) => b.price - a.price);

        } else if(ns == 'sortByAsc'){
          this.getContent = this.getContent.sort((a, b) => a.price - b.price);

        }
    
  }
  },
mounted(){
    // console.log(this.contentData.data.list)
     this.$store.state.main.scrollToTop = !this.$store.state.main.scrollToTop;
   this.$nextTick(() => {
     this.$store.state.main.updateLs3 = !this.$store.state.main.updateLs3;
     
  
   })

       if(this.filterVal == 'sortByDate'){
          this.getContent = this.getContent.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));

        }
  //  this.$store.state.main.scrollToTop = !this.$store.state.main.scrollToTop;
}
}
</script>

<style lang="scss" scoped>
  .shop .shop-list .shop-list-inner-wrapper .shop-list-box-text-block .shop-desc,
  .shop .shop-list .shop-list-inner-wrapper .shop-list-box-text-block .shop-price{
        will-change: transform;
    }
    .old-price{
      font-size: 15px;
      text-decoration: line-through;
    }
</style>